import React, { useState, useEffect } from 'react';
import { getRecycleBin, restoreQuestion, permanentDeleteQuestion, bulkRestoreQuestions } from '../../api/admin';
import AdminLayout from '../../components/AdminLayout';
import Button from '../../components/Button';
import Alert from '../../components/Alert';

export default function AdminRecycleBinPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [selected, setSelected] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await getRecycleBin();
      setList(data);
    } catch { setError('加载失败'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleRestore = async (q) => {
    try {
      await restoreQuestion(q.id);
      setSuccess(`已恢复题目：${q.stem.slice(0, 20)}...`);
      setSelected(s => s.filter(id => id !== q.id));
      load();
    } catch (e) { setError(e.response?.data?.detail || '恢复失败'); }
  };

  const handlePermanentDelete = async (q) => {
    if (!window.confirm(`永久删除该题目？此操作不可恢复！\n\n${q.stem.slice(0, 60)}`)) return;
    try {
      await permanentDeleteQuestion(q.id);
      setSuccess('已永久删除');
      setSelected(s => s.filter(id => id !== q.id));
      load();
    } catch (e) { setError(e.response?.data?.detail || '删除失败'); }
  };

  const handleBulkRestore = async () => {
    if (!selected.length) return;
    try {
      const { data } = await bulkRestoreQuestions(selected);
      setSuccess(`已批量恢复 ${data.restored} 道题目`);
      setSelected([]);
      load();
    } catch (e) { setError(e.response?.data?.detail || '批量恢复失败'); }
  };

  const toggleSelect = (id) => setSelected(s => s.includes(id) ? s.filter(i => i !== id) : [...s, id]);
  const toggleAll = () => setSelected(selected.length === list.length ? [] : list.map(q => q.id));

  return (
    <AdminLayout title="题库回收站">
      {error && <Alert type="error" style={{ marginBottom: 12 }}>{error}</Alert>}
      {success && <Alert type="success" style={{ marginBottom: 12 }}>{success}</Alert>}

      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
        <span style={{ fontSize: 13, color: '#94a3b8' }}>共 {list.length} 道已删除题目</span>
        {selected.length > 0 && (
          <Button size="sm" onClick={handleBulkRestore}>
            批量恢复（{selected.length}）
          </Button>
        )}
      </div>

      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#fef2f2' }}>
              <th style={{ padding: '10px 14px', width: 40 }}>
                <input type="checkbox" checked={selected.length === list.length && list.length > 0}
                  onChange={toggleAll} />
              </th>
              {['ID', '题干', '类型', '难度', '删除人', '删除时间', '操作'].map(h => (
                <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>加载中...</td></tr>
            ) : list.length === 0 ? (
              <tr><td colSpan={8} style={{ padding: 32, textAlign: 'center', color: '#94a3b8' }}>回收站为空</td></tr>
            ) : list.map(q => (
              <tr key={q.id} style={{ borderBottom: '1px solid #f1f5f9', background: selected.includes(q.id) ? '#fef9f2' : '#fff' }}>
                <td style={{ padding: '10px 14px' }}>
                  <input type="checkbox" checked={selected.includes(q.id)} onChange={() => toggleSelect(q.id)} />
                </td>
                <td style={{ padding: '10px 14px', color: '#94a3b8', fontSize: 12 }}>{q.id}</td>
                <td style={{ padding: '10px 14px', maxWidth: 360, color: '#374151' }}>
                  {q.stem?.slice(0, 60)}{q.stem?.length > 60 ? '...' : ''}
                </td>
                <td style={{ padding: '10px 14px', color: '#64748b' }}>
                  {{ single: '单选', multi: '多选', bool: '判断' }[q.question_type] || q.question_type}
                </td>
                <td style={{ padding: '10px 14px', color: '#64748b' }}>{q.difficulty}</td>
                <td style={{ padding: '10px 14px', color: '#94a3b8', fontSize: 12 }}>{q.deleted_by_email || '—'}</td>
                <td style={{ padding: '10px 14px', color: '#94a3b8', fontSize: 12 }}>
                  {q.deleted_at ? new Date(q.deleted_at).toLocaleDateString('zh-CN') : '—'}
                </td>
                <td style={{ padding: '10px 14px', display: 'flex', gap: 6 }}>
                  <button onClick={() => handleRestore(q)} style={{
                    padding: '4px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
                    border: '1px solid #16a34a30', background: '#f0fdf4', color: '#16a34a', fontWeight: 500,
                  }}>恢复</button>
                  <button onClick={() => handlePermanentDelete(q)} style={{
                    padding: '4px 10px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
                    border: '1px solid #dc262630', background: '#fef2f2', color: '#dc2626', fontWeight: 500,
                  }}>彻底删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
